import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

export function ExtractingSection() {
  return (
    <motion.div
      key="extracting-section"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="flex flex-col items-center justify-center min-h-[70vh]"
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.1 }}
        className="text-center"
      >
        {/* Loading spinner */}
        <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center shadow-lg shadow-blue-500/25">
          <Loader2 className="w-8 h-8 text-white animate-spin" />
        </div>

        {/* Message */}
        <h2 className="text-2xl font-semibold text-slate-900 mb-2">
          Buchungsinformationen werden extrahiert...
        </h2>
        <p className="text-slate-500">
          Dies dauert nur einen Moment
        </p>
      </motion.div>

      {/* Skeleton placeholders */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="w-full max-w-md mt-12 space-y-3"
      >
        {[1, 2, 3].map((i) => (
          <motion.div
            key={i}
            className="h-16 rounded-xl bg-gradient-to-r from-slate-200 via-slate-100 to-slate-200 border border-slate-200/50"
            animate={{ opacity: [0.6, 1, 0.6] }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              delay: i * 0.15,
            }}
          />
        ))}
      </motion.div>
    </motion.div>
  );
}
